import * as booking_select_datetime from "./booking.scenarios.select.datetime.svelte.js";
import {BUYABLE_TYPE_NON_PACKAGEDEAL, BUYABLE_TYPE_PACKAGEDEAL} from "../../AppConstants";
import {booking} from "./feature.booking.svelte.js";
import * as booking_scenarios from "./booking.scenarios.update.svelte.js";
import * as booking_select from "./booking.scenarios.select.svelte.js";
import * as products_select from "../products/products.scenarios.select.svelte.js";

// bSkipSlotWipe wordt doorgegeven aan scenarioSetArrivalTime/scenarioSetDepartureTime: op true
// (alleen bij een datumwijziging) blijven per-behandeling voorkeurstijden staan voor de Phase 2
// revalidatie i.p.v. blind gewist te worden. Default false = bestaand gedrag (wel wissen).
export function adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime(bSkipSlotWipe = false)
{
  // console.log('adjustArrivalAndDepartureTimesIfNeededBasedOnBookingAndOtherTime');
  let iArrivalTime = booking.iArrivalTime;
  let iDepartureTime = booking.iDepartureTime;

  // Eerst kijken wat puur op basis van de producten/arrangementen in de boeking de toegestane aankomst- en vertrekrange zou moeten zijn
  let iFirstPossibleArrivalTime = booking_select_datetime.getFirstPossibleArrivalTimeBasedOnBooking();
  let iLastPossibleArrivalTime = booking_select_datetime.getLastPossibleArrivalTimeBasedOnBooking();

  let iFirstPossibleDepartureTime = booking_select_datetime.getFirstPossibleDepartureTimeBasedOnBooking();

  // iLastPossibleDepartureTime houdt ook al rekening met badenkaart 2 uurs
  let iLastPossibleDepartureTime = booking_select_datetime.getLastPossibleDepartureTimeBasedOnBooking();

  // Als een van de huidige waardes niet in dat bereik ligt, resetten we die
  if ( iArrivalTime < iFirstPossibleArrivalTime || iArrivalTime > iLastPossibleArrivalTime )
  {
    iArrivalTime = false;
  }

  if ( iDepartureTime < iFirstPossibleDepartureTime || iDepartureTime > iLastPossibleDepartureTime )
  {
    iDepartureTime = false;
  }

  // nu zijn de waardes voor aankomst- en vertrektijd false of binnen het bereik, vervolgens kijken
  // of de aankomsttijd nog invloed heeft op de vertrektijd range en vice versa
  // als dat bereik moet worden aangepast op basis van wat er nu al is ingesteld als aankomst en vertrektijd dan doen we dat


  if ( iDepartureTime )
  {
    // Als vertrektijd is ingesteld, dan mag aankomst niet erna zijn
    if ( iLastPossibleArrivalTime > iDepartureTime )
    {
      iLastPossibleArrivalTime = iDepartureTime;
    }
  }

  if ( iArrivalTime )
  {
    // Als aankomsttijd is ingesteld, dan mag het vertrek daar niet voor zijn
    if ( iFirstPossibleDepartureTime < iArrivalTime )
    {
      iFirstPossibleDepartureTime = iArrivalTime;

      // Voor 14:00 is het mogelijk per kwartier te boeken
      if ( iFirstPossibleDepartureTime < 1400 )
      {
        iFirstPossibleDepartureTime += 15;
      }
      else
      {
        iFirstPossibleDepartureTime += 30;
      }
    }
  }

  console.log("EERST VERTREK", iFirstPossibleDepartureTime, booking.iFirstPossibleDepartureTime);

  // Update de toegestane ranges in de store
  booking.iFirstPossibleArrivalTime = iFirstPossibleArrivalTime;
  booking.iLastPossibleArrivalTime = iLastPossibleArrivalTime;
  booking.iFirstPossibleDepartureTime = iFirstPossibleDepartureTime;
  booking.iLastPossibleDepartureTime = iLastPossibleDepartureTime;

  // vervolgens aankomsttijd en vertrektijd binnen het toegestane bereik brengen
  // hou er rekening mee dat 1 van de 2 of beide mogelijk nog niet ingesteld zijn en dus false zijn
  let iNewArrivalTime = iArrivalTime;
  let iNewDepartureTime = iDepartureTime;

  if ( iArrivalTime && iArrivalTime < iFirstPossibleArrivalTime )
  {
    iNewArrivalTime = iFirstPossibleArrivalTime;
  }
  else if ( iArrivalTime && iArrivalTime > iLastPossibleArrivalTime )
  {
    iNewArrivalTime = iLastPossibleArrivalTime;
  }

  if ( iDepartureTime && iDepartureTime < iFirstPossibleDepartureTime )
  {
    iNewDepartureTime = iFirstPossibleDepartureTime;
  }
  else if ( iDepartureTime && iDepartureTime > iLastPossibleDepartureTime )
  {
    iNewDepartureTime = iLastPossibleDepartureTime;
  }

  // ok de waardes van aankomst en vertrek zitten nu binnen de waardes die toegestaan zijn voor de gekozen producten in de boeking
  // maar het kan nog steeds zo zijn dat de gekozen vertrektijd bijvoorbeeld nog voor de gekozen/gecorrigeerde eindtijd ligt
  // dat soort conflicten lossen we nu nog op
  if ( iNewArrivalTime && iNewDepartureTime && iNewArrivalTime > iNewDepartureTime )
  {
    iNewArrivalTime = iNewDepartureTime;
  }

  // Update de tijden in de store als deze zijn veranderd
  if ( iNewArrivalTime !== iArrivalTime || iNewArrivalTime === false )
  {
    //booking.iArrivalTime = iNewArrivalTime;
    console.log('AANKOMST CHECK', iNewDepartureTime);
    booking_scenarios.scenarioSetArrivalTime(iNewArrivalTime, true, bSkipSlotWipe)
  }

  if ( iNewDepartureTime !== iDepartureTime || iNewDepartureTime === false )
  {
    // booking.iDepartureTime = iNewDepartureTime;
    // booking.sDepartureTime = DateTimeUtil.getTimeAsStringWithSemicolonFromJoinedHoursMinInt(iNewDepartureTime);

    booking_scenarios.scenarioSetDepartureTime(iNewDepartureTime, true, bSkipSlotWipe)
  }
}
